
<div class="agpr-labelSpacing">
    <label id="bulkActionFormFolder_autocompleteLabel">
        {{ heading | localize }}
        <span class="agpr-labelSpacing-required" aria-hidden="true">*</span>
    </label>
    <span
        *ngIf="tooltip"
        role="img"
        class="agpr-infoIconStyle fa-regular fa-circle-info"
        [agprTooltip]="tooltip"
    ></span>
</div>
@if (multiSelection) {
    <agpr-autocomplete
        [id]="'bulk.action.folders'"
        class="agpr-bulkActionFormFolder-autocomplete--multiSelection"
        labelField="name"
        placeholder="Monitoring.folderPicker.placeholder.generic"
        [dropdown]="true"
        [(ngModel)]="selectedFolders"
        (itemSelected)="folderSelected($event)"
        [customOptions]="customOptions"
        [suggestions]="folderList$"
        [multiSelection]="true"
        [clearOnBlur]="true"
        [required]="true"
        panelStyleClass="agpr-bulkActionFormFolder-autoCompletePanel"
        ariaLabelledBy="bulkActionFormFolder_autocompleteLabel"
        [showHiddenOption]="true"
    ></agpr-autocomplete>
    <agpr-chip-container
        [id]="'bulk.action.chips'"
        class="agpr-bulkActionFormFolder-chipContainer--multiSelection"
        [chips]="chips"
        emptyMessage="Monitoring.folderPicker.chips.empty"
        overflowMessage="Monitoring.folderPicker.chips.overflow"
        (removeChip)="removeChip($event)"
    ></agpr-chip-container>
}
@else {
    <agpr-autocomplete
        [id]="'bulk.action.folders'"
        labelField="name"
        placeholder="Monitoring.folderPicker.placeholder.generic"
        [dropdown]="true"
        [(ngModel)]="selectedFolder"
        (itemSelected)="folderSelected($event)"
        [customOptions]="customOptions"
        [suggestions]="folderList$"
        [clearOnBlur]="false"
        [required]="true"
        panelStyleClass="agpr-bulkActionFormFolder-autoCompletePanel"
        ariaLabelledBy="bulkActionFormFolder_autocompleteLabel"
        [showHiddenOption]="true"
    ></agpr-autocomplete>
}
